import Plus from "./Add.svg";
import BackArrow from "./BackArrow.svg";
import ImageThumbnail from "./ImageThumbnail.svg";
import Send from "./Send.svg";
import Copy from "./Copy.svg";
import Search from "./Search.svg";

export const Icons = {
    Plus,
    BackArrow,
    ImageThumbnail,
    Send,
    Copy,
    Search
}